import Component from 'vue-class-component';
import { Mixins, Prop, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable'
import EdSectionMaterialTitle from '@/courses/components/ed-section-material-title/ed-section-material-title.vue';
import EdSectionMaterialObject from '@/courses/components/ed-section-material-object/ed-section-material-object.vue';
import { COURSE_EVENTS } from '@/content/values/events';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { SECTION_TYPES } from '@/content/values/sections';
import { COMPONENT_TYPE } from '@/courses/values/courses.values'
import { SectionsProvider } from '@/content/providers/sections.provider';
import { MaterialMixin } from '@/courses/mixins/material.mixin';
import { IparamsComponentSelected } from '@/courses/interfaces/params-component-selected'


@Component({
  name: 'ed-section-material',
  components: {
    EdSectionMaterialTitle,
    EdSectionMaterialObject,
    draggable
  }
})
export default class EdSectionMaterial extends Mixins(MaterialMixin) {

  /* Props */
  @Prop() readonly menuOptions: any[];
  @Prop() readonly level: number;
  @Prop() readonly sectionsOpened: number[];
  
  /* Data */
  public isOpened: boolean = false;
  public isSelected: boolean = false;
  public blockOpen: boolean = false;
  public dropAreaHighlight: boolean = false;
  public emptyDiv: any = null;
 
  /* Computed */
  get nodes() {
    return this.course.materials.nodes;
  }

  get spaceStyle(): any {
    return {
      paddingLeft: `${(this.sublevel * 10) + 10}px`
    }
  }

  get sublevel(): number {
    return this.level ? (this.level + 1) : 1;
  }

  get listClass() {
    return  {
      'ed-section-material__list': true,
      'drop-highlight': this.dropAreaHighlight
    }
  }

  get materialsListLength(): boolean {
    return this.materialsList?.length > 0;
  }

  get listIsEmpty() {
    return !this.materialsListLength;
  }

  get sectionDraggableClass() {
    return {
      area: {
        'draggable-area': this.listIsEmpty
      },
      ghost: this.listIsEmpty ? 'drop-space' : 'sortable-ghost'
    }
  }

  get isMovingObject() {
    return this.$store.state.CourseStore.movingObject;
  } 

  get materialsList () {
    return this.section ? this.section.materialsList : [];
  }

  get allMaterialsList() {
    return this.course?.materialsList;
  }

  /* Methods */   
  public toggleFolder(section: any) {
    this.isOpened = !this.isOpened;
    this.goToSection(section , true);
    if(!this.options.editable) {
      let sectionsOpened: number[] = this.sectionsOpened;
      if(this.section.parentId) {
        sectionsOpened.push(this.section.sectionId);
      } else {
        sectionsOpened = [this.section.sectionId]
      }
      this.$emit('opened', sectionsOpened);
      this.isOpened ? this.loadMaterialOnViewer(this.section.sectionId) : null;
      this.setFolderInStorage(this.section.sectionId, this.section.parentId);
    }      
  }

  public openSection(sectionsOpened: number[]) {
    this.$emit('opened', sectionsOpened);
  }

  public openOnAddMaterial() {
    if(!this.isOpened) {
      this.isOpened = true;
      this.$edEventBus.$emit(COURSE_EVENTS.SECTION_MATERIAL_SELECTED, {
        sectionId: this.section.sectionId,
        courseId: this.courseID,
        classId: this.classID
      });
    }
  }

  public closeSection() {
    if(this.isOpened) {
      this.isOpened = false;
    }
  }

  private setSelected({ sectionId , classId , toggle = false}:
    {sectionId: number , classId: number , toggle?: boolean , courseId?: number}) {
      this.$edEventBus.$emit(COURSES_EVENTS.SECTION_SELECTED, {
        sectionId: null,
        courseId: this.courseID,
        classId: this.classID
      });
      this.$edEventBus.$emit(COURSES_EVENTS.UNSELECT_PROJECTS);
    if(this.options.selectable && classId == this.classID) {
      this.isSelected = sectionId == this.section.sectionId;
      if(!this.isOpened && this.isSelected && !toggle) {
        this.isOpened = true;
      }
    }
  }

  private selectSection(toggle: boolean) {
    if(!this.isMovingObject) {
      this.$edEventBus.$emit(COURSE_EVENTS.SECTION_MATERIAL_SELECTED, {
        sectionId: this.section.sectionId,
        courseId: this.courseID,
        classId: this.classID,
        toggle
      });
      this.$edEventBus.$emit(COURSES_EVENTS.SECTION_SELECTED, {
        sectionId: null,
        courseId: this.courseID,
        classId: this.classID
      });
      if(!this.options.editable) {
        this.$edEventBus.$emit(COURSES_EVENTS.SECTION_OPENED, { 
          sectionId: null,
          opened: null,
          courseId: this.courseID,
          classId: this.classID
        });
      }    
    }
  }

  public goToSection(section: any , toogle: boolean = false) {
    this.selectSection(toogle);
    if(this.options.editable) {
      this.goToEditSection(section);
    } else {
      this.setTeacherPosition({
        sectionId: this.section.sectionId,
        courseId: this.section.courseId,
        classId: this.section.classId,
        isFolder: true
      });
    }
    
  }

  private goToEditSection(section: any) {
    let selectInfo: IparamsComponentSelected = { courseId: this.courseID ,
    classId: this.classID,    componentInfo: { name: COMPONENT_TYPE.LESSON_MATERIAL_CREATOR.code, 
    section: section , edition: true} };
    this.goToComponentSelected(selectInfo);
  }

  public goToCreateSection() {
    this.$edEventBus.$emit(COURSE_EVENTS.ADD_COURSE_MATERIAL, 
      { option: { type: SECTION_TYPES.SECTION.code } , section: this.section });
  }

  private loadMaterialOnViewer(sectionMaterialID: number) {
    let sectionMaterial: any = SectionsProvider.getSectionMaterialFromId(this.nodes , sectionMaterialID);
    let material: any = sectionMaterial.materials[0];
    if(material) {
      this.goToMaterialPreview({materialId: material.relatedContentId , 
      courseId: this.courseID , classId: this.classID});      
    }
  }

  public sectionMoved(element: any) {
    this.$Courses.Store.setMovingObject(false);

    /* change items to other section */
    if(element.added) {
      element.added.element.sectionParentId = this.section.sectionId;
      element.added.element.parentId = this.section.sectionId;
      if(element.added.element.data) {
        element.added.element.data.teacherOnly = element.added.element.data.teacherOnly || this.section.teacherOnly;
        let index: number = this.materialsList.findIndex((mat: any) => mat.relatedContentId ===  element.added.element.relatedContentId);
        let data: any = {
          materialId: element.added.element.relatedContentId,
          materialSectionId: this.section.sectionId,
          newOrder: index,
          courseId: this.courseID
        }
        this.$Courses.Store.moveCourseMaterialA(data);
      } else {
        element.added.element.teacherOnly = element.added.element.teacherOnly || this.section.teacherOnly;
        let index: number = this.materialsList.findIndex((sec: any) => sec.sectionId ===  element.added.element.sectionId);
        let data: any = {
          materialSectionId: element.added.element.sectionId,
          newMaterialSectionParentId: this.section.sectionId,
          newOrder: index,
          courseId: this.courseID
        }
        this.$Courses.Store.moveCourseMaterialSectionA(data);
      }
    }

    /* reorder items */ 
    if(element.moved) {
      if(element.moved.element.data) {
        let index: number = this.materialsList.findIndex((mat: any) => mat.relatedContentId ===  element.moved.element.relatedContentId);
        let data: any = {
          materialId: element.moved.element.relatedContentId,
          materialSectionId: this.section.sectionId,
          newOrder: index,
          courseId: this.courseID
        }
        this.$Courses.Store.moveCourseMaterialA(data);  
      } else {        
        let index: number = this.materialsList.findIndex((sec: any) => sec.sectionId ===  element.moved.element.sectionId);
        let data: any = {
          materialSectionId: element.moved.element.sectionId,
          newMaterialSectionParentId: this.section.sectionId,
          newOrder: index,
          courseId: this.courseID
        }
        this.$Courses.Store.moveCourseMaterialSectionA(data);
      }      
    }

    this.setDropHighlight();

  }

  private setWatchDragFiles() {
    let folder = document.getElementById(this.section.sectionId);
    if(folder) {
      folder.addEventListener('dragstart', () => {
        if(this.options.editable) this.blockOpen = true;
      });
      folder.addEventListener('dragover' , () => {
        if(!this.blockOpen && this.options.editable) this.isOpened = true;
      });
      folder.addEventListener('dragend', () => {
        if(this.options.editable) this.blockOpen = false;
      });
    }
  }

  private setFolderOpened(data: any) {
    if(data.materialSelected) {
      let included = data.listIds.includes(this.section.sectionId);
      if(!included) this.isOpened = false;
      return;
    }
    this.isOpened = false;
  }

  public moving(e) {
    this.$Courses.Store.setMovingObject(true);
    if(e.to.className == 'parent-empty') {
      e.to.children[0].classList.add('edg-d--none');
      this.emptyDiv = e.to.children[0];
    } else {
      if(this.emptyDiv) {
        this.emptyDiv.classList.remove('edg-d--none');
        this.emptyDiv = null;
      }
    }
    if([...e.related.classList].includes('section-material')) 
      this.$edEventBus.$emit(COURSES_EVENTS.MATERIAL_OPENED, { opened: true, sectionId: e.related.childNodes[0].id });
    return true;
  }

  public setDropHighlight(value = false) {
    this.dropAreaHighlight = value;
  }

  public sectionMoveEnd(e) {
    this.$Courses.Store.setMovingObject(false);
  }

  /* Watchers */
  @Watch('sectionsOpened', { immediate: false, deep: true })
  setOpenSection(sectionsOpened: number[]) {
    let isOpenSection: boolean = sectionsOpened.includes(this.section.sectionId);
    if(!isOpenSection) {
      this.closeSection();
      this.setSelected({ sectionId: null , classId: this.classID});
    }
  }

  @Watch('isMovingObject', { immediate: false })
  isMovingObjectChanged(value) {
    if(!value) {
      this.setDropHighlight();
    }
  }

  materialOpened({opened, sectionId}) {
    if(sectionId == this.section.sectionId) {
      this.isOpened = opened
    }
  }

  /* Hooks */  
  created() {
    this.$edEventBus.$on(COURSES_EVENTS.MATERIAL_OPENED, this.materialOpened);
    this.$edEventBus.$on(COURSE_EVENTS.SECTION_MATERIAL_SELECTED, this.setSelected);
    this.$edEventBus.$on(COURSES_EVENTS.SECTION_SELECTED , ({ sectionId, courseId, classId }) => {
      if(sectionId && courseId == this.courseID && classId == this.classID) {
        !this.options.editable ? this.isOpened = false : null;
        this.isSelected = false;
      }
    });
    this.$edEventBus.$on(COURSES_EVENTS.KEEP_OPEN_FOLDERS, this.setFolderOpened);
  }

  mounted() {
    this.setWatchDragFiles();
  }
}